import React from 'react';
import { Link } from 'react-router';

const DetailsFooter = () => (
    <div className="mtl ptl centerify">
        <hr />
        <ul>
            <li className="mvm">
                <Link to="/hva-er-trygg-betaling" className="stone">
                    Hvordan fungerer Trygg betaling?
                </Link>
            </li>
            <li>
                <a
                    target="_blank"
                    href="https://payment.schibsted.no/terms?locale=nb_NO&client_id=54d9f9411b1d797b5a8b4567"
                    className="stone"
                >
                    Vilkår
                </a>
            </li>
        </ul>
    </div>
);

export default DetailsFooter;



// WEBPACK FOOTER //
// ./safeTrade/detailsFooter.jsx